var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLike(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.60986 13.7628L7.93486 15.5628C8.23486 15.8628 8.90986 16.0128 9.35986 16.0128H12.2099C13.1099 16.0128 14.0849 15.3378 14.3099 14.4378L16.1099 8.96284C16.4849 7.91284 15.8099 7.01284 14.6849 7.01284H11.6849C11.2349 7.01284 10.8599 6.63784 10.9349 6.11284L11.3099 3.71284C11.4599 3.03784 11.0099 2.28784 10.3349 2.06284C9.73486 1.83784 8.98486 2.13784 8.68486 2.58784L5.60986 7.16284",
    stroke: "#A3A3A3",
    strokeWidth: 1.2,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.78491 13.7633V6.41328C1.78491 5.36328 2.23491 4.98828 3.28491 4.98828H4.03491C5.08491 4.98828 5.53491 5.36328 5.53491 6.41328V13.7633C5.53491 14.8133 5.08491 15.1883 4.03491 15.1883H3.28491C2.23491 15.1883 1.78491 14.8133 1.78491 13.7633Z",
    stroke: "#A3A3A3",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLike);
export default __webpack_public_path__ + "static/media/like.9d3fb8004c93dce53914c71bc2807c04.svg";
export { ForwardRef as ReactComponent };